module.exports = __webpack_public_path__ + "media/images/bg/headers/testimonials-79f621ef67f1dababde6b793c18d624a.svg";